import request from "@/utils/request";
import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 获取广告位置
export function getBestAdPlacement (data) {
  return request({
    url: GateWay + "/advertisement/getWxAdPlacement",
    method: "post",
    data
  });
}
// 获取广告列表
export function getBestAdInfo (data) {
  return request({
    url: GateWay + "/advertisement/getBid",
    method: "post",
    data
  });
}
